import { MemberSearchQuery_members } from '@frontend/app/queries/types/MemberSearchQuery';
import { ISocialAccount } from '@components';
import { useDemographicsProps } from '@/shadcn/components/demographics/hooks/useDemographics';
import { MemberDemographicsAdapter } from '../adapters/member-demographics-adapter';

/**
 * Hook to extract and format demographics data for the DemographicsSection component
 * Uses the generic useDemographicsProps hook with a member-specific adapter
 */
export const useMemberDemographics = (
  member: MemberSearchQuery_members | null,
  socialData?: ISocialAccount | null,
  isLoading?: boolean,
  defaultTab: string = 'age',
  layout: 'side-by-side' | 'stacked' = 'stacked',
) => {
  const adapter = new MemberDemographicsAdapter();

  return useDemographicsProps(
    { member, socialData }, // Combined data source
    adapter,
    isLoading ?? false,
    defaultTab,
    layout
  );
};
